import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { UserFilterComponent } from '../../abstract-user/user-filter/user-filter.component';
import { AdminDefinition } from '../../../../core/store/admin/admin-definitions/admin-definitions.interface';
import { util } from '../../../../core/util/util';

@Component({
  selector: 'admin-client-user-filter',
  templateUrl: './client-user-filter.component.html',
  styleUrls: ['../../abstract-user/user-filter/user-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class ClientUserFilterComponent extends UserFilterComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() readonly soldTos: AdminDefinition[] = [];
  @Output() readonly salesOrganisationSelected = new EventEmitter<string>();

  _salesOrganisations: AdminDefinition[];
  @Input()
  set salesOrganisations(adminDefinitions: AdminDefinition[]){
    this._salesOrganisations = adminDefinitions.map(def => {
      return {
        ...def,
        name: def.id + ' - ' + def.name
      }
    })
  }
  get salesOrganisations():AdminDefinition[] {
    return this._salesOrganisations;
  }

  soldToFieldIsInvalid = false;

  constructor(formBuilder: UntypedFormBuilder) {
    super(formBuilder);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.userFilterForm.get('soldToIds').valueChanges.subscribe((newSoldToIds: string[]) => {
      this.soldToFieldIsInvalid = newSoldToIds.length === 0 && (!util.isNilOrEmpty(this.userFilterForm.get('salesOrganisationIds').value));
    });
    this.userFilterForm.get('salesOrganisationIds').valueChanges.subscribe(newSalesOrganisationId => {
      this.userFilterForm.get('soldToIds').setValue([]);
      this.salesOrganisationSelected.emit(newSalesOrganisationId);
      this.soldToFieldIsInvalid = !util.isNilOrEmpty(newSalesOrganisationId) && (this.userFilterForm.get('soldToIds').value as string[]).length === 0;
    });
  }

  protected getControlsConfig() {
    return Object.assign(super.getControlsConfig(), {
      isTransporter: [true],
      isNotTransporter: [true],
      usesEmailActors:[true],
      cannotUseEmailActors:[true],
    });
  }

  filterClicked(): void {
    if (!this.isLoading && !this.soldToFieldIsInvalid) {
      this.filterUsers.emit(this.userFilterForm);
    }
  }


  resetFilter() {
    super.resetFilter();
    this.soldToFieldIsInvalid = false;
  }
}
